import { ArrowUp } from "lucide-react";
import { scrollToTarget } from "./ui-bits";

export default function BackToTop() {
  return (
    <button
      onClick={() => scrollToTarget("#hero")}
      aria-label="Back to top"
      data-testid="gototop-button"
      className="fixed bottom-5 right-5 z-[80] flex h-11 w-[41px] items-center justify-center border border-white/20 bg-ink/90 text-cream shadow-[0_10px_24px_-10px_rgba(0,0,0,0.9)] backdrop-blur-sm transition-colors hover:border-ember hover:text-ember"
    >
      <ArrowUp className="h-5 w-5" strokeWidth={1.75} />
    </button>
  );
}
